import React from "react";
import ContainerMd from "./Layouts/ContainerMd";
import LogoWithLanguage from "./logo-with-language/LogoWithLanguage";
import LoginHero from "../assets/heroes/waiting-bg.png";

type FullPageMessageProps = {
  title: string;
  body: string;
};
export default function FullPageMessage(props: FullPageMessageProps) {
  const { title, body } = props;
  return (
    <div className="flex min-h-screen">
      <div className="flex flex-col justify-between flex-1 px-4 py-12 sm:px-6 lg:flex-none lg:px-24">
        <div className="flex flex-col items-center justify-center gap-4 sm:gap-0 sm:justify-between sm:flex-row">
          <LogoWithLanguage />
        </div>
        <div className="flex flex-col justify-center flex-1 w-full max-w-md">
          <div>
            <h2 className="mt-6 text-3xl font-bold text-gray-700">{title}</h2>
            <p className="text-gray-500 text-lg mt-4">{body}</p>
          </div>
        </div>
        {/* <div /> */}
      </div>
      <div className="relative flex-1 hidden w-0 lg:block">
        <img
          className="absolute inset-0 object-cover w-full h-full"
          src={LoginHero}
          alt=""
        />
      </div>
    </div>
  );
}
